import SimInfoDetailModal from './sim-info-detail-modal.vue'
export default SimInfoDetailModal
